"use client";
import TitleComp from "@/components/titleBox";
import {
  cooperationList01,
  cooperList02,
  formFieldList,
  logoList,
} from "@/constants/about";
import { registerService } from "@/services/register";
import { Button, Col, Form, Input, message, Row } from "antd";
import styles from "./index.module.scss";
import _ from "lodash";
import AboutLayout from "@/components/about";


export default function AboutCompany() {
  async function onFinish(values: any) {
    const res = await registerService(values);
    if (_.get(res, "code") === "10000") {
      message.success(_.get(res, "msg") || "提交成功");
    } else {
      message.error(_.get(res, "msg"));
    }
  }

  return (
    <AboutLayout>
      <div className={styles.aboutCooper+' wrapper hCenter'}>
        <TitleComp {...cooperationList01} />
        <div className={styles["cooperList"] + " mediaCooperList"}>
          <Row gutter={{ lg: 50, xs: 0, sm: 0, md: 0 }}>
            {cooperList02.map(
              (
                c: { name: string; cont: string; imgUrl: string },
                i: number
              ) => {
                return (
                  <Col lg={8} xs={24} sm={24} md={24} key={i}>
                    <div className={styles["box"]}>
                      <img src={c.imgUrl} />
                      <div className={styles.name}>{c.name}</div>
                      <div className={styles.cont + " cont"}>{c.cont}</div>
                    </div>
                  </Col>
                );
              }
            )}
          </Row>
        </div>
        <Row gutter={[10, 30]} justify="center" className={styles.logoList}>
          {logoList.map((l: string, k: number) => {
            if (l) {
              return (
                <Col lg={5} xs={10} sm={10} md={10} key={k}>
                  <img src={l} />
                </Col>
              );
            }
          })}
        </Row>

        <h6 className={styles["cooperTit"]}>生态合作</h6>
        <div className={styles.cooperForm}>
          <Form
            name="basic"
            wrapperCol={{ span: 12 }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            //onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            {formFieldList.map((field: any, k: number) => {
              return (
                <div className={styles.customItem} key={k}>
                  <Form.Item
                    {...field.itemProps}
                    colon={false}
                    labelAlign="left"
                  >
                    <Input {...field.compProps} />
                  </Form.Item>
                </div>
              );
            })}

            <Button type="primary" className={styles.subBtn} htmlType="submit">
              确认提交意向合作表
            </Button>
          </Form>
        </div>
      </div>
    </AboutLayout>
  );
}
